import { ShellContent } from '../../components/Shell';
import styles from './Malfunctions.module.css';
import { Button } from '../../components/Button';
import { FormattedMessage } from 'react-intl';
import { useMalfunctions } from '../../services/malfunctions';
import { PlaceCenter } from '../../components/PlaceCenter';
import { Spinner } from '../../components/Spinner';
import { DelayUnmount } from '../../components/DelayUnmount';
import {
  CreateMalfunction,
  setCreateMalfunctionDialog,
  useCreateMalfunctionDialog,
} from '../../components/CreateMalfunction';
import { useIsFeatureEnabledInObject } from '../../services/features';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { MalfunctionPreview } from '../../components/MalfunctionPreview';

export const Malfunctions = () => {
  const open = useCreateMalfunctionDialog();
  const { result, running } = useMalfunctions();

  return (
    <ShellContent>
      <div className={styles.root} data-testid="malfunctions-page">
        <Button
          data-testid="new-malfunction-btn"
          onClick={() => setCreateMalfunctionDialog(true)}
        >
          <FormattedMessage tagName="div" id="Malfunctions.New" />
        </Button>
        <div className={styles.container}>
          <div className={styles.title}>
            <FormattedMessage id="Malfunctions" />
          </div>
          <div className={styles.list}>
            {running && (
              <PlaceCenter>
                <Spinner />
              </PlaceCenter>
            )}
            {!running && (
              <>
                {!result?.length && (
                  <span className="light">
                    <FormattedMessage id="Malfunctions.Empty" />
                  </span>
                )}
                {result?.map(({ name, id }) => (
                  <Link
                    key={id}
                    className={styles.item}
                    data-testid="malfunction-item"
                    to={`/malfunctions/${id}`}
                  >
                    {name}
                  </Link>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
      <DelayUnmount unmount={!open}>
        <CreateMalfunction
          open={open}
          onClose={() => setCreateMalfunctionDialog(false)}
        />
      </DelayUnmount>
    </ShellContent>
  );
};

export const MalfunctionsFeature = () => {
  const { id } = useParams<{ id: string }>();
  const enabled = useIsFeatureEnabledInObject('MALFUNCTION');
  const navigate = useNavigate();

  if (!enabled) return <Navigate to="/" replace />;

  return (
    <>
      <Malfunctions />
      <DelayUnmount unmount={!id}>
        <MalfunctionPreview
          open={!!id}
          onClose={() => navigate('/malfunctions')}
          id={id}
        />
      </DelayUnmount>
    </>
  );
};
